import { render, staticRenderFns } from "./BranchDetail.vue?vue&type=template&id=3794417c&scoped=true"
import script from "./BranchDetail.vue?vue&type=script&lang=ts"
export * from "./BranchDetail.vue?vue&type=script&lang=ts"
import style0 from "./BranchDetail.vue?vue&type=style&index=0&id=3794417c&lang=scss"
import style1 from "./BranchDetail.vue?vue&type=style&index=1&id=3794417c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3794417c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3794417c')) {
      api.createRecord('3794417c', component.options)
    } else {
      api.reload('3794417c', component.options)
    }
    module.hot.accept("./BranchDetail.vue?vue&type=template&id=3794417c&scoped=true", function () {
      api.rerender('3794417c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/branch/components/BranchDetail.vue"
export default component.exports